module.exports = __webpack_public_path__ + "static/media/i24.07d21ea2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/i24.svg
// module id = 195
// module chunks = 12